import { pickListData, useChats } from "../hooks/useChatData";

export default function Sidebar({ selectedId, onSelect, onDelete, isOpen }) {
  const { data, isLoading, isError } = useChats();
  const items = pickListData(data);

  return (
    <aside className={`ia-sidebar ${isOpen ? "is-open" : ""}`}>
      <div className="ia-sidebar__header">
        <div className="ia-sidebar__title">Conversas</div>
        <button
          className="ia-sidebar__new-message"
          onClick={(e) => {
            e.stopPropagation();
            onSelect(null);
          }}
          aria-label="Iniciar conversa"
          title="Iniciar conversa"
        >
          <i class="bi bi-pencil"></i>
        </button>
        {
          /* Botão para ocultar a sidebar */
        }
      </div>
      {isLoading && <div className="ia-sidebar__hint">Carregando…</div>}
      {isError && (
        <div className="ia-sidebar__hint ia--error">Erro ao carregar</div>
      )}

      <ul className="ia-sidebar__list">
        {items.map((c) => (
          <li
            key={c.id}
            className={`ia-sidebar__item ${
              selectedId === c.id ? "is-active" : ""
            }`}
            onClick={() => onSelect(c.id)}
          >
            <div
              className="ia-sidebar__item-title"
              title={c.title || `Conversa #${c.id}`}
            >
              {c.title || `Conversa #${c.id}`}
            </div>
            <button
              className="ia-sidebar__delete"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(c.id);
              }}
              aria-label="Excluir conversa"
              title="Excluir"
            >
              ×
            </button>
          </li>
        ))}
        {items.length === 0 && !isLoading && (
          <li className="ia-sidebar__hint">Nenhuma conversa ainda.</li>
        )}
      </ul>
    </aside>
  );
}
